import api from "./base";

/**
 * Fetch events from the server for a given date range and adapt them to FullCalendar format.
 * @param {string} startDate - ISO string (YYYY-MM-DD)
 * @param {string} endDate - ISO string (YYYY-MM-DD)
 * @returns {Promise<Array>} Array of events formatted for FullCalendar
 */
export async function fetchCalendarEvents(startDate, endDate) {
    const response = await api.post("/events/range", {
        startDate,
        endDate,
    });
    return (response.data || []).map(eventAdapter).filter(Boolean);
}

/**
 * Fetch a single event by ID and adapt it to FullCalendar format.
 * @param {string|number} id
 * @returns {Promise<Object>} Event object formatted for FullCalendar
 */
export async function fetchEventById(id) {
    const response = await api.get(`/events/${id}`);
    return eventAdapter(response.data);
}

export const eventTypesTexts = {
    break: "הפסקה",
    lesson: "שיעור",
    vacation: "חופשה",
    test: "טסט",
    internalTest: "טסט פנימי",
    lessonRequest: "בקשה לקביעת שיעור",
    cancelationRequest: "בקשה לביטול שיעור",
    google: "אירוע מיומן Google",
    googleFullDay: "אירוע מיומן Google",
}

export const eventTypeColors = {
    lesson: '#3366FF',
    test: '#81C784',
    internalTest: '#FFB74D',
    break: '#e6e6e6',
    vacation: '#e6e6e6',
    lessonRequest: '#D2E3FC',
    cancelationRequest: '#FF0000',
    google: '#f8ddff',
    googleFullDay: '#f8ddff',
    default: '#ECEFF1',
}

export const eventTypeTextColors = {
    break: '#212121',
    lesson: '#ffffff',
    vacation: '#212121',
    test: '#fff',
    internalTest: '#fff',
    lessonRequest: '#212121',
    cancelationRequest: '#FFFFFF',
    google: '#212121',
    googleFullDay: '#212121',
    default: '#212121',
}

/**
 * Adapter to convert server event to FullCalendar event format
 * @param {Object} event
 * @returns {Object}
 */
function eventAdapter(event) {
    let priority = 0;
    switch (event.type) {
        case 'lesson':
            priority = 3;
            break;
        case 'test':
            priority = 5;
            break;
        case 'internalTest':
            priority = 4;
            break;
        case 'lessonRequest':
            priority = 2;
            break;
        case 'break':
            priority = 1;
            break;
        default:
            priority = 0;
    }

    if(!event.startTime || !event.endTime) {
        return null
    }

    return {
        id: String(event.id),
        title: event?.label ? event.label : event.student ? `${[event.student.firstName, event.student.lastName].filter(Boolean).join(' ')}` : event.type ? eventTypesTexts[event.type] : "אירוע ללא כותרת",
        start: event.startTime,
        end: event.endTime,
        priority,
        allDay: event.type === 'vacation' || event.type === 'googleFullDay',
        color: eventTypeColors[event.type] || eventTypeColors.default,
        textColor: eventTypeTextColors[event.type] || eventTypeTextColors.default,
        extendedProps: {
            teacher: event.teacher,
            student: event.student,
            type: event.type,
            notes: event.notes,
            price: event.price,
            label: event.label,
            ...event
        }
    };
} 